export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "invoice_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuver ou refuser la facture"])},
        "quotation_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuver ou refuser le devis"])},
        "approve_invoice_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuver la facture"])},
        "refuse_invoice_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuser la facture"])},
        "handling_type_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez spécifier la prise en charge"])},
        "approve_quotation_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuver le devis"])},
        "refuse_quotation_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuser le devis"])},
        "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
        "confirm_refusal_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer le refus"])}
      },
      "en": {
        "invoice_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approve or refuse the invoice"])},
        "quotation_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approve or refuse the quotation"])},
        "approve_invoice_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approve the invoice"])},
        "refuse_invoice_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuse the invoice"])},
        "handling_type_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please specify the handling"])},
        "approve_quotation_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approve the quotation"])},
        "refuse_quotation_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuse the quotation"])},
        "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
        "confirm_refusal_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm the refusal"])}
      }
    }
  })
}
